(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["binho-league"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('binho-league')) {
    customElements.define('binho-league', class extends HTMLElement {
      connectedCallback() {
        this.api = this.dataset.apiBase.replace(/\/$/, '');
        this.location = this.dataset.location;
        this.loggedIn = this.dataset.loggedIn === 'true';
        this.customerName = this.dataset.customerName;
        this.copy = JSON.parse(this.querySelector('[data-binho-copy]').textContent);
        this.data = null;
        this.bindTabs();
        this.bindForms();
        this.load();
      }

      bindTabs() {
        this.querySelectorAll('[data-binho-tab]').forEach((button) => {
          button.addEventListener('click', () => {
            const name = button.dataset.binhoTab;
            this.querySelectorAll('[data-binho-tab]').forEach((item) => item.classList.toggle('is-active', item === button));
            this.querySelectorAll('[data-binho-panel]').forEach((panel) => {
              const active = panel.dataset.binhoPanel === name;
              panel.classList.toggle('is-active', active);
              panel.hidden = !active;
            });
          });
        });
        this.querySelector('[data-binho-ranking]')?.addEventListener('change', (event) => this.renderLeaderboard(event.target.value));
      }

      bindForms() {
        this.querySelector('[data-binho-match-form]')?.addEventListener('submit', (event) => this.submitMatch(event));
        this.querySelector('[data-binho-event-form]')?.addEventListener('submit', (event) => this.submitEvent(event));
        this.addEventListener('click', (event) => {
          const action = event.target.closest('[data-match-action]');
          if (action) this.resolveMatch(action.dataset.matchId, action.dataset.matchAction);
        });
      }

      async load() {
        try {
          if (this.loggedIn && this.customerName) {
            await this.request('/profile', {
              method: 'POST',
              body: JSON.stringify({ display_name: this.customerName, location: this.location })
            });
          }
          this.data = await this.request(`/bootstrap?location=${encodeURIComponent(this.location)}`);
          this.render();
        } catch (error) {
          this.notice(error.message || this.copy.loadError);
        }
      }

      async request(path, options = {}) {
        const response = await fetch(`${this.api}${path}`, {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
          ...options
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || this.copy.loadError);
        return payload;
      }

      render() {
        this.querySelector('[data-binho-season]').textContent = this.data.season?.name || '—';
        this.renderLeaderboard(this.querySelector('[data-binho-ranking]').value);
        this.renderOpponents();
        this.renderPending();
        this.renderEvents();
        this.renderProfile();
        const admin = this.querySelector('[data-binho-event-form]');
        if (admin) admin.hidden = !this.data.viewer?.is_admin;
      }

      renderLeaderboard(sortKey = 'rating') {
        if (!this.data) return;
        const rows = [...this.data.leaderboard].sort((a, b) => Number(b[sortKey] || 0) - Number(a[sortKey] || 0));
        const body = this.querySelector('[data-binho-leaderboard]');
        if (!rows.length) {
          body.innerHTML = `<tr><td colspan="5">${this.esc(this.copy.emptyLeaderboard)}</td></tr>`;
          return;
        }
        body.innerHTML = rows.map((player, index) => `
          <tr>
            <td><span class="binho__rank">${index + 1}</span></td>
            <td><span class="binho__player"><span class="binho__avatar">${this.initials(player.display_name)}</span>${this.esc(player.display_name)}</span></td>
            <td><strong>${Number(player.rating).toFixed(0)}</strong></td>
            <td>${Number(player.career_wins)}–${Number(player.career_losses)}</td>
            <td>${Number(player.goals_for)}</td>
          </tr>
        `).join('');
      }

      renderOpponents() {
        const select = this.querySelector('[data-binho-opponents]');
        if (!select || !this.data.viewer) return;
        select.innerHTML = `<option value="">${this.esc(this.copy.selectOpponent)}</option>` + this.data.players
          .filter((player) => player.id !== this.data.viewer.id)
          .map((player) => `<option value="${this.esc(player.id)}">${this.esc(player.display_name)}</option>`)
          .join('');
      }

      renderPending() {
        const target = this.querySelector('[data-binho-pending]');
        if (!target) return;
        const pending = this.data.pending_matches || [];
        if (!pending.length) {
          target.textContent = this.copy.emptyPending;
          return;
        }
        target.innerHTML = pending.map((match) => `
          <div class="binho__pending">
            <div>
              <strong>${this.esc(match.reporter_name)} ${this.esc(this.copy.vs)} ${this.esc(match.opponent_name)}</strong>
              <div>${Number(match.reporter_score)}–${Number(match.opponent_score)}</div>
            </div>
            <div class="binho__pending-actions">
              <button class="binho__mini-button" type="button" data-match-id="${this.esc(match.id)}" data-match-action="confirm">${this.esc(this.copy.confirm)}</button>
              <button class="binho__mini-button" type="button" data-match-id="${this.esc(match.id)}" data-match-action="dispute">${this.esc(this.copy.dispute)}</button>
            </div>
          </div>
        `).join('');
      }

      renderEvents() {
        const target = this.querySelector('[data-binho-events]');
        const events = this.data.events || [];
        if (!events.length) {
          target.textContent = this.copy.emptyEvents;
          return;
        }
        target.innerHTML = events.map((event) => {
          const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(event.starts_at));
          return `<article class="binho__event"><time>${this.esc(date)}</time><strong>${this.esc(event.name)}</strong><span>${this.esc(event.format_label)}</span></article>`;
        }).join('');
      }

      renderProfile() {
        const target = this.querySelector('[data-binho-profile]');
        if (!target || !this.data.viewer) return;
        const player = this.data.viewer;
        const total = Number(player.career_wins) + Number(player.career_losses);
        const winPercent = total ? Math.round((Number(player.career_wins) / total) * 100) : 0;
        target.innerHTML = `
          <p class="binho__kicker">${this.esc(this.copy.rating)} ${Number(player.rating).toFixed(0)}</p>
          <h2>${this.esc(player.display_name)}</h2>
          <div class="binho__stats">
            ${this.stat(this.copy.record, `${Number(player.career_wins)}–${Number(player.career_losses)}`)}
            ${this.stat(this.copy.winPercent, `${winPercent}%`)}
            ${this.stat(this.copy.goals, Number(player.goals_for))}
            ${this.stat(this.copy.seasonPoints, Number(player.season_points))}
            ${this.stat(this.copy.tournamentPoints, Number(player.tournament_points))}
            ${this.stat(this.copy.championships, Number(player.championships))}
          </div>
        `;
      }

      stat(label, value) {
        return `<div class="binho__stat"><span>${this.esc(label)}</span><strong>${this.esc(value)}</strong></div>`;
      }

      async submitMatch(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const values = Object.fromEntries(new FormData(form));
        const viewer = Number(values.viewer_score);
        const opponent = Number(values.opponent_score);
        if (viewer === opponent || Math.max(viewer, opponent) !== 7 || Math.min(viewer, opponent) < 0) {
          this.notice(this.copy.invalidScore);
          return;
        }
        const button = form.querySelector('button[type="submit"]');
        button.disabled = true;
        button.textContent = this.copy.saving;
        try {
          await this.request('/matches', {
            method: 'POST',
            body: JSON.stringify({
              opponent_id: values.opponent_id,
              viewer_score: viewer,
              opponent_score: opponent,
              location: this.location
            })
          });
          form.reset();
          this.notice(this.copy.matchSubmitted);
          await this.load();
        } catch (error) {
          this.notice(error.message);
        } finally {
          button.disabled = false;
          button.textContent = this.copy.matchSubmitted.replace(/[.!]$/, '');
        }
      }

      async resolveMatch(id, action) {
        try {
          await this.request(`/matches/${encodeURIComponent(id)}/${action}`, { method: 'POST', body: '{}' });
          this.notice(action === 'confirm' ? this.copy.matchConfirmed : this.copy.matchDisputed);
          await this.load();
        } catch (error) {
          this.notice(error.message);
        }
      }

      async submitEvent(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const values = Object.fromEntries(new FormData(form));
        try {
          await this.request('/admin/events', {
            method: 'POST',
            body: JSON.stringify({ ...values, location: this.location })
          });
          form.reset();
          this.notice(this.copy.eventCreated);
          await this.load();
        } catch (error) {
          this.notice(error.message);
        }
      }

      notice(message) {
        const notice = this.querySelector('[data-binho-notice]');
        notice.textContent = message;
        notice.hidden = false;
        clearTimeout(this.noticeTimer);
        this.noticeTimer = setTimeout(() => { notice.hidden = true; }, 6000);
      }

      initials(name) {
        return String(name || '?').split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
      }

      esc(value) {
        const node = document.createElement('div');
        node.textContent = String(value ?? '');
        return node.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gyro-reactor"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ardg-gyro-native')){
customElements.define('ardg-gyro-native',class extends HTMLElement{
connectedCallback(){
if(this.shadowRoot){this.cleanup?.();this.shadowRoot.replaceChildren(this.querySelector('template').content.cloneNode(true));if(this.restart)this.restart();return;}
const shadow=this.attachShadow({mode:'open'});shadow.append(this.querySelector('template').content.cloneNode(true));
this.restart=()=>{
'use strict';
// Decorative physics only; drawing selection and shared reveal timing live in the reactor service.
const MOTION_SPEED = 3;
const TAU = Math.PI * 2;
const WALL = .87;
const between = (random, low, high) => low + random() * (high - low);

function syncParticles(previous, codes, random = Math.random) {
  const existing = new Map(previous.map(p => [p.id, p]));
  const labels = [...new Set(codes.filter(c => typeof c === 'string' && /^\d{5}$/.test(c)))];
  const ids = labels.map(code => ['code:' + code, code]);
  for (let i = ids.length; i < 40; i++) ids.push(['dot:' + i, '']);
  return ids.map(([id, code]) => {
    if (existing.has(id)) return existing.get(id);
    const angle = random() * TAU;
    const radius = Math.sqrt(random()) * WALL;
    const direction = random() * TAU;
    const velocity = between(random, .12, .2);
    return {id, code, x: Math.cos(angle) * radius, y: Math.sin(angle) * radius,
      vx: Math.cos(direction) * velocity, vy: Math.sin(direction) * velocity,
      phase: 'bounce', timer: between(random, .5, 10), size: between(random, 1.6, 3.2)};
  });
}

function advanceParticles(particles, elapsed, random = Math.random, speed = MOTION_SPEED) {
  let remaining = Math.min(.1, Math.max(0, elapsed)) * speed;
  while (remaining > 0) {
    const dt = Math.min(1 / 120, remaining);
    remaining -= dt;
    for (const p of particles) {
      p.timer -= dt;
      const distance = Math.hypot(p.x, p.y);
      if (p.phase === 'bounce' && p.timer <= 0) p.phase = 'pull';
      if (p.phase === 'hold') {
        if (p.timer > 0) continue;
        const angle = random() * TAU;
        const velocity = between(random, .48, .72);
        p.x = Math.cos(angle) * .045; p.y = Math.sin(angle) * .045;
        p.vx = Math.cos(angle) * velocity; p.vy = Math.sin(angle) * velocity;
        p.phase = 'eject'; p.timer = .65;
      }
      if (p.phase === 'pull') {
        if (distance < .055) {
          p.x = p.y = p.vx = p.vy = 0;
          p.phase = 'hold'; p.timer = between(random, .22, .45);
          continue;
        }
        // Inward force plus a brief tangential curl creates the suction spiral.
        const nx = p.x / distance, ny = p.y / distance;
        p.vx += (-nx * .95 - ny * .19 - p.vx * 1.6) * dt;
        p.vy += (-ny * .95 + nx * .19 - p.vy * 1.6) * dt;
      } else if (p.phase === 'eject') {
        if (p.timer <= 0) {p.phase = 'bounce'; p.timer = between(random, 4, 9);}
      } else {
        // Gentle random steering, then a reflected collision with a random deflection.
        p.vx += between(random, -.15, .15) * dt;
        p.vy += between(random, -.15, .15) * dt;
      }
      p.x += p.vx * dt; p.y += p.vy * dt;
      const r = Math.hypot(p.x, p.y);
      if (r > WALL) {
        const nx = p.x / r, ny = p.y / r;
        p.x = nx * WALL; p.y = ny * WALL;
        const outward = p.vx * nx + p.vy * ny;
        if (outward > 0) {p.vx -= 2 * outward * nx; p.vy -= 2 * outward * ny;}
        const turn = between(random, -.4, .4), c = Math.cos(turn), s = Math.sin(turn);
        const vx = p.vx * c - p.vy * s, vy = p.vx * s + p.vy * c;
        // Keep the perturbed reflection pointing inward.
        if (vx * nx + vy * ny < 0) {p.vx = vx; p.vy = vy;}
      }
    }
  }
}

const root=this.shadowRoot.querySelector('#reactor');
root.dataset.api=this.dataset.api;root.dataset.compact=this.dataset.compact;root.dataset.watch=this.dataset.watch;root.dataset.copy=this.dataset.copy;root.dataset.speed=this.dataset.speed;
const lifecycle=new AbortController();let animationFrame=0;
if(!root)return;
const $=selector=>root.querySelector(selector), params=new URLSearchParams(location.search);
const copyDefaults={"eyebrow": "Another Round / Gyropalooza", "title_first": "Enter the", "title_second": "GYRO Reactor.", "intro_body": "Twelve boxes. One shared reveal.\nEnter for the right to purchase one of our 12 brick-and-mortar Gyropalooza boxes.", "machine_name": "GYRO // REACTOR", "status_standby": "STANDBY", "status_accepting": "ACCEPTING ENTRIES", "status_active": "ACTIVE", "status_complete": "COMPLETE", "status_reconnecting": "RECONNECTING", "core_idle": "12", "core_active": "GYRO", "core_complete": "12", "core_caption": "PURCHASE SPOTS", "core_warming": "REACTOR ACTIVATING", "core_finished": "REVEAL COMPLETE", "core_selected": "SELECTED · SPOT {spot}", "entry_count": "{count} VERIFIED ENTRIES", "privacy_stamp": "IDENTITIES CLASSIFIED", "connecting": "CONNECTING…", "connection_pending": "CONNECTION PENDING", "badge": "2026 · BRICK-AND-MORTAR BOXES", "clock_label": "Reactor activation", "coming_soon": "Drawing time coming soon", "waiting_caption": "Everyone watches the same reveal.", "scheduled_caption": "Shared reveal · {date} (your local time)", "clock_activating": "REACTOR ACTIVATING", "clock_live": "Shared reveal in progress", "clock_reconnecting": "Reconnecting to live drawing…", "clock_complete": "Drawing complete", "days_suffix": "d", "entry_title": "Your number.\nYour shot.", "entry_body": "Verify your email to receive a unique five-digit entry number. Only numbers appear in the reactor.", "name_label": "Your name", "email_label": "Email address", "consent": "I understand this drawing is for the right to purchase one box. One entry per person; email verification is required.", "entry_button": "Send my entry link ↗", "recover_title": "Already entered? Get your watch link again.", "recover_body": "Use the same name and email above. You’ll keep your existing entry number.", "closed_title": "Entry is not open.", "closed_body": "Already entered? Use your original name and email to get your watch link again. New entries are closed.", "complete_title": "The reveal is complete.", "watch_button": "Send my watch link ↗", "email_sent": "Check your email for your private entry link. If this is your first entry, open the link and confirm within 30 minutes.", "error_message": "{detail}", "verify_title": "One last step.", "verify_body": "Confirm your email to put your number into the reactor.", "verify_button": "Confirm my entry", "private_label": "Your private entry", "entered_title": "You’re entered.", "entered_body": "Keep your number. Your email link brings you back here to watch the shared drawing.", "selected_body": "Your number was selected! Contact Another Round with your entry email to arrange your purchase.", "not_selected_body": "Your number was not selected in this drawing. Thanks for entering.", "pending_body": "Your number is in the reactor.", "results_title": "12 PURCHASE SPOTS", "results_complete": "Reveal complete", "slot_label": "SPOT {spot}", "disclaimer": "No instant winners. No public names. Selected entrants receive the right to purchase one box each.", "footer": "One verified email = one entry. Your name and email stay private.", "pause": "Pause animation", "play": "Play animation", "compact_eyebrow": "Another Round / Gyropalooza", "compact_title": "The GYRO Reactor.", "compact_body": "Enter for the right to purchase one of 12 brick-and-mortar boxes.", "compact_button": "Enter the reactor ↗", "machine_aria": "Animated reactor showing anonymous entry numbers", "console_aria": "Drawing entry and countdown", "results_aria": "Selected entry numbers"};
let customCopy={};try{customCopy=JSON.parse(root.dataset.copy||'{}');}catch{}
const copy={...copyDefaults,...customCopy};
const tr=(key,values={})=>String(copy[key]??'').replace(/\{(\w+)\}/g,(match,k)=>String(values[k]??match));
root.querySelectorAll('[data-copy]').forEach(el=>el.textContent=tr(el.dataset.copy));
root.querySelectorAll('[data-copy-aria]').forEach(el=>el.setAttribute('aria-label',tr(el.dataset.copyAria)));
const animationSpeed=Math.max(0,Math.min(3,Number(root.dataset.speed??100)/100));
$('[data-clock]').textContent=tr('coming_soon');$('[data-compact-clock]').textContent=tr('coming_soon');$('[data-date]').textContent=tr('waiting_caption');$('[data-count]').textContent=tr('connecting');$('[data-core]').textContent=tr('core_idle');$('[data-core-caption]').textContent=tr('core_caption');
const demo=root.dataset.demo==='true';
const compact=params.get('compact')==='1'||root.dataset.compact==='true';
if(compact)root.classList.add('compact');
const allowedParent=/^https:\/\/(throwanotherround\.com|www\.throwanotherround\.com|another-round-disc-golf\.myshopify\.com|p025uh-f8\.myshopify\.com)$/;
let parentOrigin=null;
try{const origin=new URL(document.referrer).origin;if(allowedParent.test(origin))parentOrigin=origin;}catch{}
let watch=root.dataset.watch||'/pages/2026-b-m-gyro-drawing';
try{const u=new URL(watch,location.origin);if(!allowedParent.test(u.origin)&&u.origin!==location.origin)watch='/watch';}catch{watch='/watch';}
$('[data-watch]').href=watch;
let state=null,offset=0,lastSync=0,myCode=null,token=new URLSearchParams(location.hash.slice(1)).get('gyro'),paused=matchMedia('(prefers-reduced-motion: reduce)').matches,visible=true,lastFrame=0,visualTime=0,previousFrame=performance.now(),demoAt=null,sessionBusy=false,fetching=false;
let motionParticles=[];
const canvas=$('canvas'),ctx=canvas.getContext('2d');
const computedStyle=getComputedStyle(root);
const color=(key,fallback)=>{const value=computedStyle.getPropertyValue(key).trim();return /^#[0-9a-f]{6}$/i.test(value)?value:fallback;};
const palette={background:color('--navy','#081721'),text:color('--reactor-text','#d6f4ff'),ring:color('--ring-color','#416777'),glow:color('--glow-color','#058fec'),particle:color('--particle-color','#8fc4d9'),selected:color('--selected-color','#9effd6'),numberFont:computedStyle.getPropertyValue('--font-numbers').trim()||'ui-monospace,monospace'};
const sampleCodes=Array.from({length:30},(_,i)=>String(10107+i*2713));
if(demo){const banner=document.createElement('div');banner.className='preview-banner';banner.innerHTML='<span>DEMO · 30 SAMPLE ENTRIES · NO REAL DRAWING</span><button type="button">Preview shared reveal</button>';root.prepend(banner);banner.querySelector('button').onclick=()=>{demoAt=Date.now()+6000;banner.querySelector('button').textContent='Restart demo';poll();};}
async function api(path,body){const r=await fetch(root.dataset.api.replace(/\/$/,'')+'/api/'+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined,cache:'no-store',credentials:'omit',signal:lifecycle.signal});let data;try{data=await r.json();}catch{throw new Error('The reactor is not connected yet. Please check back soon.');}if(!r.ok)throw new Error(data.error||'Please try again.');return data;}
function message(el,text,error=false){el.textContent=error?tr('error_message',{detail:text}):text;el.className='notice '+(error?'error':'success');}
function setPersonal(code){myCode=code;$('[data-entry]').hidden=true;$('[data-verify]').hidden=true;$('[data-entered]').hidden=false;$('[data-your-number]').textContent=code;render();}
async function session(){if(!token||sessionBusy||compact)return;sessionBusy=true;try{if(demo)return;const s=await api('session',{token});if(s.code)setPersonal(s.code);else{$('[data-entry]').hidden=true;$('[data-verify]').hidden=false;}}catch(e){message($('[data-entry-message]'),e.message,true);}finally{sessionBusy=false;}}
$('[data-entry-form]').addEventListener('submit',async e=>{e.preventDefault();const button=e.target.querySelector('button'),fields=new FormData(e.target);button.disabled=true;try{if(demo){message($('[data-entry-message]'),'Preview only. Live entry will be available after setup.');return;}const res=await api('request-entry',{name:fields.get('name'),email:fields.get('email'),website:fields.get('website')});message($('[data-entry-message]'),tr('email_sent'));}catch(err){message($('[data-entry-message]'),err.message,true);}finally{button.disabled=false;}});
$('[data-confirm]').addEventListener('click',async e=>{e.target.disabled=true;try{const s=await api('verify',{token});setPersonal(s.code);await poll();}catch(err){message($('[data-verify-message]'),err.message,true);}finally{e.target.disabled=false;}});
const onHashChange=()=>{token=new URLSearchParams(location.hash.slice(1)).get('gyro');session();};window.addEventListener('hashchange',onHashChange,{signal:lifecycle.signal});
const motionButton=$('[data-motion]'),motionFooter=$('.footer'),machinePanel=document.createElement('div');
machinePanel.className='machine-panel';const machine=$('.machine');machine.before(machinePanel);machinePanel.append(machine);
function placeMotion(){const target=matchMedia('(max-width:800px)').matches?machinePanel:motionFooter;if(motionButton.parentElement!==target)target.append(motionButton);}
placeMotion();
motionButton.onclick=()=>{paused=!paused;updateMotion();};
function updateMotion(){$('[data-motion]').textContent=paused?tr('play'):tr('pause');}updateMotion();
function countdown(ms){if(ms<=0)return tr('clock_activating');const total=Math.ceil(ms/1000),days=Math.floor(total/86400),hours=Math.floor(total%86400/3600),mins=Math.floor(total%3600/60),secs=total%60;return(days?days+tr('days_suffix')+' ':'')+String(hours).padStart(2,'0')+':'+String(mins).padStart(2,'0')+':'+String(secs).padStart(2,'0');}
function render(){if(!state)return;const now=Date.now()+offset,stale=Date.now()-lastSync>12000;
const scheduled=state.drawAt&&now>=state.drawAt;
let clock=state.drawAt?countdown(state.drawAt-now):tr('coming_soon');
if(state.phase==='complete')clock=tr('clock_complete');else if(scheduled)clock=stale?tr('clock_reconnecting'):tr('clock_live');
$('[data-clock]').textContent=clock;$('[data-compact-clock]').textContent=clock;
$('[data-date]').textContent=state.drawAt?tr('scheduled_caption',{date:new Intl.DateTimeFormat(undefined,{dateStyle:'medium',timeStyle:'short'}).format(new Date(state.drawAt))}):tr('waiting_caption');
$('[data-count]').textContent=tr('entry_count',{count:String(state.entryCount).padStart(2,'0')});
$('[data-machine-status]').textContent=stale?tr('status_reconnecting'):state.phase==='complete'?tr('status_complete'):scheduled?tr('status_active'):state.open?tr('status_accepting'):tr('status_standby');
const winners=state.winners||[],latest=winners.at(-1),displayLatest=latest&&state.phase!=='complete';
$('[data-core]').textContent=displayLatest?latest:state.phase==='complete'?tr('core_complete'):scheduled?tr('core_active'):tr('core_idle');
$('[data-core]').classList.toggle('winning-code',!!displayLatest);
$('[data-core-caption]').textContent=displayLatest?tr('core_selected',{spot:String(winners.length).padStart(2,'0')}):state.phase==='complete'?tr('core_finished'):scheduled?tr('core_warming'):tr('core_caption');
$('[data-reveal-status]').textContent=tr('results_complete');
$('[data-slots]').closest('.results').hidden=state.phase!=='complete';
const signature=state.phase+'|'+winners.join(',')+'|'+myCode;
if($('[data-slots]').dataset.signature!==signature){$('[data-slots]').dataset.signature=signature;$('[data-slots]').replaceChildren(...Array.from({length:state.phase==='complete'?winners.length:0},(_,i)=>{const slot=document.createElement('div');slot.className='slot'+(winners[i]?' revealed':'')+(winners[i]===myCode?' mine':'');const small=document.createElement('small');small.textContent=tr('slot_label',{spot:String(i+1).padStart(2,'0')});const strong=document.createElement('strong');strong.textContent=winners[i]||'— — —';slot.append(small,strong);return slot;}));}
if(myCode){$('[data-personal-result]').textContent=winners.includes(myCode)?tr('selected_body'):state.phase==='complete'?tr('not_selected_body'):tr('pending_body');}
const form=$('[data-entry-form]');if(!myCode&&!token){form.hidden=false;$('[data-entry] h2').textContent=state.open?tr('entry_title'):state.phase==='complete'?tr('complete_title'):tr('closed_title');$('[data-entry] > p').textContent=state.open?tr('entry_body'):tr('closed_body');form.querySelector('button').textContent=state.open?tr('entry_button'):tr('watch_button');}
}
async function poll(){if(fetching||!visible)return;fetching=true;const start=Date.now();try{let data;if(demo){const elapsed=demoAt?Date.now()-demoAt:-1,n=Math.min(12,Math.max(0,Math.floor((elapsed-10000)/4500)+1));data={serverNow:Date.now(),open:!demoAt||elapsed<0,drawAt:demoAt,phase:elapsed<0?'waiting':n<12?'drawing':'complete',entryCount:30,codes:sampleCodes,winners:sampleCodes.slice().reverse().slice(0,n),winnerCount:12,warmup:10000,interval:4500};}else data=await api('state');const end=Date.now();offset=data.serverNow-(start+end)/2;state=data;motionParticles=syncParticles(motionParticles,state.codes||[]);lastSync=end;render();}catch(e){if(!state){$('[data-count]').textContent=tr('connection_pending');message($('[data-entry-message]'),e.message,true);}else render();}finally{fetching=false;}}
let pixels=1,width=600;
const canvasObserver=new ResizeObserver(entries=>{placeMotion();const w=entries[0].contentRect.width;width=w;pixels=Math.min(devicePixelRatio||1,2);canvas.width=Math.round(w*pixels);canvas.height=Math.round(w*pixels);});canvasObserver.observe(canvas.parentElement);
const visibilityObserver=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;if(visible)poll();});visibilityObserver.observe(root);
document.addEventListener('visibilitychange',()=>{if(!document.hidden){poll();render();}},{signal:lifecycle.signal});
function draw(time){animationFrame=requestAnimationFrame(draw);const delta=time-previousFrame;if(!visible||document.hidden||time-lastFrame<33)return;previousFrame=time;lastFrame=time;if(!paused){visualTime+=Math.min(delta,100)*animationSpeed*3;advanceParticles(motionParticles,Math.min(delta,100)/1000,Math.random,animationSpeed*3);}const w=width,c=w/2,t=visualTime,r=w*.44;ctx.setTransform(pixels,0,0,pixels,0,0);ctx.clearRect(0,0,w,w);
const now=Date.now()+offset,active=state?.drawAt&&now>=state.drawAt&&state.phase!=='complete',pulse=paused?0.5:(Math.sin(t/750)+1)/2;
const glow=ctx.createRadialGradient(c,c,0,c,c,r);glow.addColorStop(0,palette.glow+(active?'55':'33'));glow.addColorStop(.45,palette.background);glow.addColorStop(1,palette.background);ctx.fillStyle=glow;ctx.fillRect(0,0,w,w);
for(let i=0;i<4;i++){ctx.beginPath();ctx.arc(c,c,r-i*w*.055,0,Math.PI*2);ctx.strokeStyle=i===0?palette.ring:palette.ring+'66';ctx.lineWidth=i===0?2:1;ctx.stroke();}
for(let i=0;i<96;i++){const a=i*Math.PI/48,outer=r+w*.027,inner=outer-(i%8===0?w*.018:w*.006);ctx.beginPath();ctx.moveTo(c+Math.cos(a)*inner,c+Math.sin(a)*inner);ctx.lineTo(c+Math.cos(a)*outer,c+Math.sin(a)*outer);ctx.strokeStyle=i%8===0?palette.ring:palette.ring+'66';ctx.stroke();}
for(let i=0;i<3;i++){const a=t*.00015*(i%2?-1:1)+i*2.1;ctx.beginPath();ctx.arc(c,c,w*.18+i*w*.018,a,a+1.1);ctx.strokeStyle=active?palette.glow:palette.ring;ctx.lineWidth=2;ctx.stroke();}
ctx.beginPath();ctx.arc(c,c,w*(.165+pulse*.003),0,Math.PI*2);ctx.strokeStyle=palette.glow;ctx.lineWidth=1.5;ctx.shadowColor=palette.glow;ctx.shadowBlur=active?25:10;ctx.stroke();ctx.shadowBlur=0;
ctx.save();ctx.beginPath();ctx.arc(c,c,r,0,Math.PI*2);ctx.clip();
for(const p of motionParticles){
 if(p.phase==='hold')continue;
 const selected=state?.winners.includes(p.code),mine=p.code===myCode;
 const px=c+p.x*r,py=c+p.y*r,scale=p.phase==='pull'?Math.min(1,Math.max(.1,Math.hypot(p.x,p.y)/.22)):1;
 ctx.globalAlpha=scale;ctx.strokeStyle=palette.glow;ctx.lineWidth=p.phase==='eject'?1.8:1;
 ctx.beginPath();ctx.moveTo(px,py);ctx.lineTo(px-p.vx*r*.06,py-p.vy*r*.06);ctx.stroke();
 ctx.beginPath();ctx.arc(px,py,Math.max(1,w*.003)*scale,0,Math.PI*2);ctx.fillStyle=selected?palette.selected:mine?palette.text:p.code?palette.particle:palette.glow;ctx.fill();
 if(p.code){ctx.font=`${mine?'bold ':''}${(compact?Math.max(5,w*.021):Math.max(9,w*.024))*scale}px ${palette.numberFont}`;ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(p.code,px,py-w*.018*scale);}
}
ctx.restore();ctx.globalAlpha=1;
if(active&&!paused&&animationSpeed>0)for(let i=0;i<26;i++){const a=i*2.4+t*.0004,rr=w*(.07+((i*.037+t*.00012)%1)*.23);ctx.fillStyle=palette.glow;ctx.globalAlpha=.15+(i%4)*.1;ctx.fillRect(c+Math.cos(a)*rr,c+Math.sin(a)*rr,1.5,1.5);}ctx.globalAlpha=1;
if(active&&state.winners.length){const elapsed=now-state.drawAt-state.warmup-(state.winners.length-1)*state.interval,progress=Math.max(0,Math.min(1,elapsed/1100*animationSpeed));if(progress<1&&!paused&&animationSpeed>0){ctx.beginPath();ctx.arc(c,c-w*.24*progress,w*.014+Math.sin(progress*Math.PI)*w*.025,0,Math.PI*2);ctx.fillStyle=palette.selected;ctx.shadowBlur=25;ctx.shadowColor=palette.selected;ctx.fill();ctx.shadowBlur=0;}}
}
const renderTimer=setInterval(render,1000),pollTimer=setInterval(poll,2000);animationFrame=requestAnimationFrame(draw);poll();session();
this.cleanup=()=>{lifecycle.abort();clearInterval(renderTimer);clearInterval(pollTimer);cancelAnimationFrame(animationFrame);canvasObserver.disconnect();visibilityObserver.disconnect();};

};this.restart();
}
disconnectedCallback(){this.cleanup?.();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-calendar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('release-calendar')) {
    class ReleaseCalendar extends HTMLElement {
      connectedCallback() {
        if (this.initialized || !this.dataset.calendarId || !this.dataset.apiKey) return;
        this.initialized = true;
        this.app = this.querySelector('.release-calendar__app');
        this.today = new Date();
        this.viewDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
        this.selectedDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
        this.mobileView = 'month';
        this.activeCategory = 'all';
        this.events = [];
        this.productImages = new Map();
        this.collectionImages = new Map();
        this.brandLogos = Array.from(this.querySelectorAll('[data-brand-logo]'))
          .map((logo) => ({ name: logo.dataset.brandName, image: logo.dataset.brandImage }))
          .filter((logo) => logo.name && logo.image)
          .sort((a, b) => b.name.length - a.name.length);
        this.labels = {
          all: this.dataset.labelAll,
          disc: this.dataset.labelDisc,
          apparel: this.dataset.labelApparel,
          merch: this.dataset.labelMerch,
          restock: this.dataset.labelRestock,
          event: this.dataset.labelEvent,
          add: this.dataset.labelAdd,
          google: this.dataset.labelGoogle,
          ics: this.dataset.labelIcs,
          copy: this.dataset.labelCopy,
          copied: this.dataset.labelCopied,
          today: this.dataset.labelToday,
          empty: this.dataset.labelEmpty,
          loading: this.dataset.labelLoading,
          error: this.dataset.labelError,
          upcoming: this.dataset.labelUpcoming,
          categories: this.dataset.labelCategories,
          previous: this.dataset.labelPrevious,
          next: this.dataset.labelNext,
          close: this.dataset.labelClose,
          more: this.dataset.labelMore,
          products: this.dataset.labelProducts,
          productsHeading: this.dataset.labelProductsHeading,
          details: this.dataset.labelDetails,
          viewCollection: this.dataset.labelViewCollection,
          viewFullCalendar: this.dataset.labelViewFullCalendar,
          backToMonth: this.dataset.labelBackToMonth
        };
        this.categoryColors = {
          disc: '#f7342f',
          apparel: '#8b5cf6',
          merch: '#f59e0b',
          restock: '#0ea5e9',
          event: '#10b981'
        };
        this.loadEvents();
      }

      async loadEvents(centerDate = this.viewDate) {
        this.setLoading();
        const monthsAhead = Number(this.dataset.monthsAhead || 12);
        const start = new Date(centerDate.getFullYear(), centerDate.getMonth() - 2, 1);
        const end = new Date(centerDate.getFullYear(), centerDate.getMonth() + monthsAhead + 1, 1);
        const params = new URLSearchParams({
          key: this.dataset.apiKey,
          timeMin: start.toISOString(),
          timeMax: end.toISOString(),
          singleEvents: 'true',
          orderBy: 'startTime',
          maxResults: '2500'
        });
        const calendarId = encodeURIComponent(this.dataset.calendarId);
        const url = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?${params}`;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Calendar request failed: ${response.status}`);
          const payload = await response.json();
          this.events = (payload.items || [])
            .filter((item) => item.status !== 'cancelled' && item.start)
            .map((item) => this.normalizeEvent(item))
            .sort((a, b) => a.start - b.start);
          this.loadedStart = start;
          this.loadedEnd = end;
          this.render();
          this.hydrateProducts();
        } catch (error) {
          console.error('[Release calendar]', error);
          this.app.innerHTML = `<div class="release-calendar__error" role="alert">${this.escape(this.labels.error)}</div>`;
        }
      }

      setLoading() {
        this.app.innerHTML = `<div class="release-calendar__loading"><span class="release-calendar__spinner" aria-hidden="true"></span><span>${this.escape(this.labels.loading)}</span></div>`;
      }

      normalizeEvent(item) {
        const rawDescription = item.description || '';
        const allDay = Boolean(item.start.date);
        const startRaw = item.start.dateTime || `${item.start.date}T00:00:00`;
        const endRaw = item.end?.dateTime || `${item.end?.date || item.start.date}T00:00:00`;
        const meta = this.parseDescription(rawDescription);
        const products = this.extractProducts(rawDescription);
        let collection = this.extractCollection(rawDescription);
        const imageUrl = this.metadataUrl(rawDescription, 'image') || this.firstLink(meta.image) || this.firstUrl(this.plainText(meta.image));
        const metadataLink = this.metadataUrl(rawDescription, 'collection') || this.metadataUrl(rawDescription, 'link') || this.metadataUrl(rawDescription, 'product') || this.firstLink(meta.link) || this.firstUrl(this.plainText(meta.link));
        if (metadataLink && this.isProductUrl(metadataLink) && !products.some((product) => product.url === metadataLink)) {
          products.push({ title: '', url: metadataLink, imageUrl: '' });
        }
        if (metadataLink && this.isCollectionUrl(metadataLink) && !collection) {
          collection = { title: '', url: metadataLink, imageUrl: '' };
        }
        const cleanDescription = this.cleanEventDescription(meta.description, products, imageUrl, collection);
        const categoryMatch = (item.summary || '').match(/^\s*\[(disc|apparel|merch|restock|event)\]\s*/i);
        const category = (meta.category || categoryMatch?.[1] || 'disc').toLowerCase();
        const safeCategory = this.categoryColors[category] ? category : 'disc';
        const title = (item.summary || 'Untitled release').replace(/^\s*\[[^\]]+\]\s*/, '').trim();

        return {
          id: item.id,
          uid: item.iCalUID || item.id,
          title,
          category: safeCategory,
          start: new Date(startRaw),
          end: new Date(endRaw),
          startRaw: item.start.dateTime || item.start.date,
          endRaw: item.end?.dateTime || item.end?.date || item.start.date,
          allDay,
          description: cleanDescription,
          products,
          collection,
          imageUrl,
          location: item.location || '',
          sourceUrl: item.htmlLink || ''
        };
      }

      parseDescription(description) {
        const meta = { category: '', link: '', image: '', description: '' };
        const content = [];
        description.split(/\r?\n/).forEach((line) => {
          const match = line.match(/^\s*(category|link|product|image)\s*:\s*(.+)\s*$/i);
          if (!match) {
            content.push(line);
            return;
          }
          const key = match[1].toLowerCase();
          if (key === 'category') meta.category = match[2].trim();
          if (key === 'link' || key === 'product') meta.link = match[2].trim();
          if (key === 'image') meta.image = match[2].trim();
        });
        meta.description = content.join('\n').trim();
        return meta;
      }

      firstUrl(text) {
        return text.match(/https?:\/\/[^\s<]+/i)?.[0]?.replace(/[),.;]+$/, '') || '';
      }

      firstLink(html) {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        return documentFragment.querySelector('a[href]')?.href || '';
      }

      metadataUrl(html, key) {
        const separators = '(?:\\s|<br\\s*\\/?>|<\\/?(?:div|p)[^>]*>)*';
        const pattern = new RegExp(`${key}\\s*:?${separators}(?:<a[^>]*href=["']([^"']+)["'][^>]*>|(https?:\\/\\/[^\\s<]+))`, 'i');
        const match = html.match(pattern);
        if (!match) return '';
        const documentFragment = new DOMParser().parseFromString(`<a href="${match[1] || match[2]}"></a>`, 'text/html');
        return documentFragment.querySelector('a')?.href || '';
      }

      plainText(html) {
        const withLineBreaks = html
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<\/p>/gi, '\n');
        const documentFragment = new DOMParser().parseFromString(withLineBreaks, 'text/html');
        return (documentFragment.body.textContent || '')
          .replace(/\n{3,}/g, '\n\n')
          .trim();
      }

      isProductUrl(value) {
        try {
          return new URL(value, window.location.origin).pathname.includes('/products/');
        } catch (error) {
          return false;
        }
      }

      isCollectionUrl(value) {
        try {
          return new URL(value, window.location.origin).pathname.includes('/collections/');
        } catch (error) {
          return false;
        }
      }

      extractProducts(html) {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const products = [];
        documentFragment.querySelectorAll('a[href]').forEach((anchor) => {
          const url = anchor.href;
          if (!this.isProductUrl(url) || products.some((product) => product.url === url)) return;
          const title = anchor.textContent.trim();
          products.push({
            title: title === url ? '' : title,
            url,
            imageUrl: ''
          });
        });
        return products;
      }

      extractCollection(html) {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const anchor = Array.from(documentFragment.querySelectorAll('a[href]'))
          .find((item) => this.isCollectionUrl(item.href));
        if (!anchor) return null;
        const title = anchor.textContent.trim();
        return {
          title: title === anchor.href ? '' : title,
          url: anchor.href,
          imageUrl: ''
        };
      }

      cleanEventDescription(html, products, imageUrl = '', collection = null) {
        const productTitles = products.map((product) => product.title).filter(Boolean);
        return this.plainText(html)
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line)
          .filter((line) => !/^products?\s*:?$/i.test(line))
          .filter((line) => !/^(image|link|product|collection|category)\s*:/i.test(line))
          .filter((line) => !imageUrl || line !== imageUrl)
          .filter((line) => !productTitles.includes(line))
          .filter((line) => !products.some((product) => line === product.url))
          .filter((line) => !collection || line !== collection.title)
          .filter((line) => !collection || line !== collection.url)
          .join('\n')
          .trim();
      }

      render() {
        if (this.dataset.layout === 'upcoming') {
          this.renderUpcomingOnly();
          return;
        }

        this.app.innerHTML = `
          ${this.filtersMarkup()}
          <div class="release-calendar__desktop">
            ${this.toolbarMarkup()}
            <div class="release-calendar__desktop-layout">
              ${this.monthMarkup()}
              <aside class="release-calendar__sidebar">
                <h3 class="release-calendar__sidebar-title">${this.escape(this.labels.upcoming)}</h3>
                <div class="release-calendar__cards">${this.upcomingCardsMarkup(6)}</div>
              </aside>
            </div>
          </div>
          <div class="release-calendar__mobile">
            ${this.mobileView === 'day' ? this.mobileDayMarkup() : `${this.toolbarMarkup()}${this.monthMarkup(true)}`}
          </div>
          ${this.modalMarkup()}
        `;
        this.bindEvents();
      }

      renderUpcomingOnly() {
        this.app.innerHTML = `
          ${this.filtersMarkup()}
          ${this.carouselMarkup(Number(this.dataset.eventLimit || 6))}
          ${this.fullCalendarLinkMarkup()}
          ${this.modalMarkup()}
        `;
        this.bindEvents();
      }

      filtersMarkup() {
        return `<div class="release-calendar__filters" aria-label="${this.escape(this.labels.categories)}">
          ${['all', 'disc', 'apparel', 'merch', 'restock', 'event'].map((category) => `
            <button class="release-calendar__filter" type="button" data-category="${category}" aria-pressed="${this.activeCategory === category}">${this.escape(this.labels[category])}</button>
          `).join('')}
        </div>`;
      }

      toolbarMarkup() {
        const title = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(this.viewDate);
        return `<div class="release-calendar__toolbar">
          <div class="release-calendar__month-nav">
            <button class="release-calendar__icon-button" type="button" data-action="previous" aria-label="${this.escape(this.labels.previous)}">${this.chevron('left')}</button>
            <h3 class="release-calendar__month-title">${this.escape(title)}</h3>
            <button class="release-calendar__icon-button" type="button" data-action="next" aria-label="${this.escape(this.labels.next)}">${this.chevron('right')}</button>
          </div>
          <button class="release-calendar__today" type="button" data-action="today">${this.escape(this.labels.today)}</button>
        </div>`;
      }

      monthMarkup(isMobile = false) {
        const weekdays = Array.from({ length: 7 }, (_, index) => {
          const date = new Date(2024, 0, 7 + index);
          return new Intl.DateTimeFormat(undefined, { weekday: 'short' }).format(date);
        });
        const first = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1);
        const gridStart = new Date(first);
        gridStart.setDate(first.getDate() - first.getDay());
        const cells = [];

        for (let index = 0; index < 42; index += 1) {
          const date = new Date(gridStart);
          date.setDate(gridStart.getDate() + index);
          const dayEvents = this.eventsForDate(date).slice(0, 3);
          const total = this.eventsForDate(date).length;
          const outside = date.getMonth() !== this.viewDate.getMonth();
          const today = this.sameDay(date, this.today);
          const mobileAttributes = isMobile
            ? ` role="button" tabindex="0" data-mobile-date="${this.dateKey(date)}" aria-label="${this.escape(new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(date))}, ${total} ${this.escape(this.labels.products)}"`
            : '';
          cells.push(`<div class="release-calendar__day${outside ? ' release-calendar__day--outside' : ''}${today ? ' release-calendar__day--today' : ''}"${mobileAttributes}>
            <span class="release-calendar__date">${date.getDate()}</span>
            ${dayEvents.map((event) => this.eventPillMarkup(event)).join('')}
            ${total > 3 ? `<p class="release-calendar__more">+${total - 3} ${this.escape(this.labels.more)}</p>` : ''}
          </div>`);
        }

        return `<div class="release-calendar__month">
          <div class="release-calendar__weekdays">${weekdays.map((day) => `<div class="release-calendar__weekday">${this.escape(day)}</div>`).join('')}</div>
          <div class="release-calendar__grid">${cells.join('')}</div>
        </div>`;
      }

      eventPillMarkup(event) {
        const time = event.allDay ? '' : new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(event.start);
        return `<button class="release-calendar__event-pill" type="button" data-event-id="${this.escape(event.id)}" style="--event-color: ${this.categoryColors[event.category]}">${time ? `${this.escape(time)} · ` : ''}${this.escape(event.title)}</button>`;
      }

      agendaMarkup() {
        const monthStart = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1);
        const monthEnd = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 1);
        const events = this.filteredEvents().filter((event) => event.start >= monthStart && event.start < monthEnd);
        if (!events.length) return `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`;

        const groups = new Map();
        events.forEach((event) => {
          const key = this.dateKey(event.start);
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(event);
        });

        return Array.from(groups.entries()).map(([key, dayEvents]) => {
          const date = new Date(`${key}T12:00:00`);
          const heading = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(date);
          return `<h3 class="release-calendar__agenda-heading">${this.escape(heading)}</h3>${dayEvents.map((event) => this.cardMarkup(event)).join('')}`;
        }).join('');
      }

      upcomingCardsMarkup(limit) {
        const now = new Date();
        const events = this.filteredEvents().filter((event) => event.end >= now).slice(0, limit);
        if (!events.length) return `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`;
        return events.map((event) => this.cardMarkup(event)).join('');
      }

      carouselMarkup(limit) {
        const now = new Date();
        const events = this.filteredEvents().filter((event) => event.end >= now).slice(0, limit);
        if (!events.length) return `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`;
        return `<div class="release-calendar__carousel" data-carousel>
          <div class="release-calendar__carousel-header">
            <h3 class="release-calendar__carousel-title">${this.escape(this.labels.upcoming)}</h3>
            <div class="release-calendar__carousel-controls">
              <button class="release-calendar__icon-button" type="button" data-carousel-action="previous" aria-label="${this.escape(this.labels.previous)}">${this.chevron('left')}</button>
              <button class="release-calendar__icon-button" type="button" data-carousel-action="next" aria-label="${this.escape(this.labels.next)}">${this.chevron('right')}</button>
            </div>
          </div>
          <div class="release-calendar__carousel-track" data-carousel-track>
            ${events.map((event) => this.cardMarkup(event, 'carousel')).join('')}
          </div>
        </div>`;
      }

      fullCalendarLinkMarkup() {
        if (!this.dataset.fullCalendarUrl) return '';
        return `<div class="release-calendar__full-link-wrap">
          <a class="release-calendar__full-link" href="${this.escape(this.dataset.fullCalendarUrl)}">
            ${this.escape(this.labels.viewFullCalendar)} <span class="release-calendar__full-link-arrow" aria-hidden="true">→</span>
          </a>
        </div>`;
      }

      mobileDayMarkup() {
        const heading = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(this.selectedDate);
        const events = this.eventsForDate(this.selectedDate);
        return `<div class="release-calendar__mobile-day" data-mobile-day-view>
          <div class="release-calendar__mobile-day-header">
            <button class="release-calendar__icon-button" type="button" data-day-action="previous" aria-label="${this.escape(this.labels.previous)}">${this.chevron('left')}</button>
            <h3 class="release-calendar__mobile-day-title">${this.escape(heading)}</h3>
            <button class="release-calendar__icon-button" type="button" data-day-action="next" aria-label="${this.escape(this.labels.next)}">${this.chevron('right')}</button>
          </div>
          <div class="release-calendar__mobile-day-cards" data-mobile-day-swipe>
            ${events.length ? events.map((event) => this.cardMarkup(event)).join('') : `<div class="release-calendar__empty">${this.escape(this.labels.empty)}</div>`}
          </div>
          <button class="release-calendar__back-to-month" type="button" data-action="back-to-month">${this.escape(this.labels.backToMonth)}</button>
        </div>`;
      }

      cardMarkup(event, variant = 'compact') {
        const hasImage = this.dataset.showImages === 'true' && event.imageUrl;
        const date = new Intl.DateTimeFormat(undefined, {
          weekday: 'short', month: 'short', day: 'numeric',
          ...(event.allDay ? {} : { hour: 'numeric', minute: '2-digit' })
        }).format(event.start);
        return `<article class="release-calendar__card release-calendar__card--${variant}${hasImage ? '' : ' release-calendar__card--no-image'}" data-event-card data-event-id="${this.escape(event.id)}" style="--event-color: ${this.categoryColors[event.category]}">
          ${hasImage ? `<img class="release-calendar__card-image${event.brandLogo ? ' release-calendar__card-image--brand' : ''}" src="${this.escape(event.imageUrl)}" alt="" width="188" height="188" loading="lazy">` : ''}
          <div class="release-calendar__card-content">
            <span class="release-calendar__category">${this.escape(this.labels[event.category])}</span>
            <h3 class="release-calendar__card-title">${this.escape(event.title)}</h3>
            <p class="release-calendar__card-time">${this.escape(date)}</p>
            ${event.products.length ? `<p class="release-calendar__card-time">${event.products.length} ${this.escape(this.labels.products)}</p>` : ''}
            <div class="release-calendar__card-actions">
              <button class="release-calendar__button" type="button" data-event-id="${this.escape(event.id)}">${this.escape(variant === 'carousel' ? this.labels.details : this.labels.add)}</button>
            </div>
          </div>
        </article>`;
      }

      modalMarkup() {
        return `<div class="release-calendar__modal" hidden>
          <div class="release-calendar__modal-backdrop" data-action="close"></div>
          <div class="release-calendar__modal-panel" role="dialog" aria-modal="true" aria-labelledby="ReleaseCalendarModalTitle-${this.dataset.sectionId}">
            <button class="release-calendar__icon-button release-calendar__modal-close" type="button" data-action="close" aria-label="${this.escape(this.labels.close)}">&times;</button>
            <div class="release-calendar__modal-content"></div>
          </div>
        </div>`;
      }

      openModal(event) {
        const modal = this.querySelector('.release-calendar__modal');
        const content = modal.querySelector('.release-calendar__modal-content');
        const googleUrl = this.googleCalendarUrl(event);
        content.innerHTML = `
          <span class="release-calendar__category release-calendar__modal-category" style="--event-color: ${this.categoryColors[event.category]}; color: ${this.categoryColors[event.category]}">${this.escape(this.labels[event.category])}</span>
          <h3 class="release-calendar__modal-title" id="ReleaseCalendarModalTitle-${this.dataset.sectionId}">${this.escape(event.title)}</h3>
          <p class="release-calendar__modal-time">${this.escape(this.longDate(event))}</p>
          ${event.description ? `<div class="release-calendar__modal-description">${this.escape(event.description)}</div>` : ''}
          ${this.productListMarkup(event)}
          <div class="release-calendar__modal-actions">
            <a class="release-calendar__modal-button" href="${this.escape(googleUrl)}" target="_blank" rel="noopener">${this.escape(this.labels.google)}</a>
            <button class="release-calendar__modal-button release-calendar__modal-button--secondary" type="button" data-action="ics">${this.escape(this.labels.ics)}</button>
            <button class="release-calendar__modal-button release-calendar__modal-button--secondary" type="button" data-action="copy">${this.escape(this.labels.copy)}</button>
            ${event.collection ? `<a class="release-calendar__modal-button release-calendar__modal-button--secondary" href="${this.escape(event.collection.url)}">${this.escape(this.labels.viewCollection)}</a>` : ''}
          </div>`;
        modal.hidden = false;
        modal.dataset.eventId = event.id;
        document.body.classList.add('release-calendar-modal-open');
        modal.querySelector('[data-action="close"]').focus();
      }

      productListMarkup(event) {
        if (!event.products.length) return '';
        return `<div class="release-calendar__product-list">
          <h4 class="release-calendar__product-list-title">${this.escape(this.labels.productsHeading)}</h4>
          ${event.products.map((product) => `
            <a class="release-calendar__product-item" href="${this.escape(product.url)}">
              ${product.imageUrl
                ? `<img class="release-calendar__product-image" src="${this.escape(product.imageUrl)}" alt="" width="116" height="116" loading="lazy">`
                : '<span class="release-calendar__product-placeholder" aria-hidden="true"></span>'}
              <span class="release-calendar__product-name">${this.escape(product.title || 'View product')}</span>
              <span class="release-calendar__product-arrow" aria-hidden="true">›</span>
            </a>
          `).join('')}
        </div>`;
      }

      closeModal() {
        const modal = this.querySelector('.release-calendar__modal');
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('release-calendar-modal-open');
      }

      bindEvents() {
        this.querySelectorAll('[data-category]').forEach((button) => {
          button.addEventListener('click', () => {
            this.activeCategory = button.dataset.category;
            this.render();
          });
        });
        this.querySelectorAll('[data-event-id]').forEach((element) => {
          if (element.tagName === 'A') return;
          element.addEventListener('click', (clickEvent) => {
            if (element.hasAttribute('data-event-card') && clickEvent.target.closest('a, button')) return;
            const event = this.events.find((item) => item.id === element.dataset.eventId);
            if (event) this.openModal(event);
          });
        });
        this.querySelectorAll('[data-carousel-action]').forEach((button) => {
          button.addEventListener('click', () => {
            const carousel = button.closest('[data-carousel]');
            const track = carousel?.querySelector('[data-carousel-track]');
            const card = track?.querySelector('.release-calendar__card');
            if (!track || !card) return;
            const gap = Number.parseFloat(getComputedStyle(track).gap) || 16;
            const distance = card.getBoundingClientRect().width + gap;
            track.scrollBy({
              left: button.dataset.carouselAction === 'next' ? distance : -distance,
              behavior: 'smooth'
            });
          });
        });
        this.querySelectorAll('[data-mobile-date]').forEach((day) => {
          const openDay = () => {
            this.selectedDate = this.dateFromKey(day.dataset.mobileDate);
            this.mobileView = 'day';
            this.render();
          };
          day.addEventListener('click', (event) => {
            if (event.target.closest('[data-event-id]')) return;
            openDay();
          });
          day.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openDay();
            }
          });
        });
        this.querySelectorAll('[data-day-action]').forEach((button) => {
          button.addEventListener('click', () => this.changeSelectedDay(button.dataset.dayAction === 'next' ? 1 : -1));
        });
        this.querySelector('[data-action="back-to-month"]')?.addEventListener('click', () => {
          this.mobileView = 'month';
          this.viewDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
          this.render();
        });
        const swipeArea = this.querySelector('[data-mobile-day-swipe]');
        if (swipeArea) {
          let touchStartX = 0;
          let touchStartY = 0;
          swipeArea.addEventListener('touchstart', (event) => {
            touchStartX = event.changedTouches[0].clientX;
            touchStartY = event.changedTouches[0].clientY;
          }, { passive: true });
          swipeArea.addEventListener('touchend', (event) => {
            const deltaX = event.changedTouches[0].clientX - touchStartX;
            const deltaY = event.changedTouches[0].clientY - touchStartY;
            if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
              this.changeSelectedDay(deltaX < 0 ? 1 : -1);
            }
          }, { passive: true });
        }
        this.querySelectorAll('[data-action="previous"]').forEach((button) => button.addEventListener('click', () => this.changeMonth(-1)));
        this.querySelectorAll('[data-action="next"]').forEach((button) => button.addEventListener('click', () => this.changeMonth(1)));
        this.querySelectorAll('[data-action="today"]').forEach((button) => button.addEventListener('click', () => {
          this.viewDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
          this.selectedDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
          this.render();
        }));
        this.querySelectorAll('[data-action="close"]').forEach((button) => button.addEventListener('click', () => this.closeModal()));
        this.querySelector('[data-action="ics"]')?.addEventListener('click', () => {
          const event = this.eventFromModal();
          if (event) this.downloadIcs(event);
        });
        this.querySelector('[data-action="copy"]')?.addEventListener('click', async (clickEvent) => {
          const event = this.eventFromModal();
          if (!event) return;
          const url = this.googleCalendarUrl(event);
          await navigator.clipboard.writeText(url);
          clickEvent.currentTarget.textContent = this.labels.copied;
        });
        this.removeEventListener('keydown', this.handleKeydown);
        this.addEventListener('keydown', this.handleKeydown);
      }

      handleKeydown = (event) => {
        if (event.key === 'Escape') this.closeModal();
      };

      eventFromModal() {
        const id = this.querySelector('.release-calendar__modal')?.dataset.eventId;
        return this.events.find((event) => event.id === id);
      }

      changeMonth(amount) {
        this.viewDate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + amount, 1);
        if (this.viewDate < this.loadedStart || this.viewDate > this.loadedEnd) {
          this.loadEvents(this.viewDate);
        } else {
          this.render();
        }
      }

      changeSelectedDay(amount) {
        const nextDate = new Date(this.selectedDate);
        nextDate.setDate(nextDate.getDate() + amount);
        this.selectedDate = nextDate;
        this.viewDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), 1);
        if (nextDate < this.loadedStart || nextDate >= this.loadedEnd) {
          this.loadEvents(this.viewDate);
        } else {
          this.render();
        }
      }

      filteredEvents() {
        if (this.activeCategory === 'all') return this.events;
        return this.events.filter((event) => event.category === this.activeCategory);
      }

      eventsForDate(date) {
        return this.filteredEvents().filter((event) => {
          if (event.allDay) return this.dateKey(event.start) === this.dateKey(date);
          return this.sameDay(event.start, date);
        });
      }

      sameDay(a, b) {
        return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
      }

      dateKey(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      dateFromKey(key) {
        const [year, month, day] = key.split('-').map(Number);
        return new Date(year, month - 1, day);
      }

      longDate(event) {
        return new Intl.DateTimeFormat(undefined, {
          weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
          ...(event.allDay ? {} : { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })
        }).format(event.start);
      }

      googleCalendarUrl(event) {
        const params = new URLSearchParams({
          action: 'TEMPLATE',
          text: event.title,
          dates: this.calendarDateRange(event),
          details: this.eventDetails(event),
          location: event.location,
          ctz: this.dataset.timeZone
        });
        return `https://calendar.google.com/calendar/render?${params}`;
      }

      eventDetails(event) {
        const productLines = event.products.map((product) => `${product.title || 'Product'}: ${product.url}`);
        return [
          event.description,
          productLines.length ? `${this.labels.productsHeading}:\n${productLines.join('\n')}` : '',
          event.collection ? `${this.labels.viewCollection}: ${event.collection.url}` : ''
        ].filter(Boolean).join('\n\n');
      }

      calendarDateRange(event) {
        if (event.allDay) {
          return `${event.startRaw.replaceAll('-', '')}/${event.endRaw.replaceAll('-', '')}`;
        }
        return `${this.utcStamp(event.start)}/${this.utcStamp(event.end)}`;
      }

      utcStamp(date) {
        return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      }

      downloadIcs(event) {
        const escapeIcs = (value = '') => value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
        const start = event.allDay ? `DTSTART;VALUE=DATE:${event.startRaw.replaceAll('-', '')}` : `DTSTART:${this.utcStamp(event.start)}`;
        const end = event.allDay ? `DTEND;VALUE=DATE:${event.endRaw.replaceAll('-', '')}` : `DTEND:${this.utcStamp(event.end)}`;
        const ics = [
          'BEGIN:VCALENDAR', 'VERSION:2.0', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
          'PRODID:-//Another Round Disc Golf//Release Calendar//EN', 'BEGIN:VEVENT',
          `UID:${escapeIcs(event.uid)}`, `DTSTAMP:${this.utcStamp(new Date())}`, start, end,
          `SUMMARY:${escapeIcs(event.title)}`,
          `DESCRIPTION:${escapeIcs(this.eventDetails(event))}`,
          `LOCATION:${escapeIcs(event.location)}`,
          event.collection ? `URL:${escapeIcs(event.collection.url)}` : '',
          'BEGIN:VALARM', 'TRIGGER:-PT1H', 'ACTION:DISPLAY', `DESCRIPTION:${escapeIcs(event.title)}`,
          'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'
        ].filter(Boolean).join('\r\n');
        const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${event.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'release'}.ics`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(link.href);
      }

      async hydrateProducts() {
        const candidates = this.events.flatMap((event) =>
          event.products.map((product) => ({ event, product }))
        ).filter(({ product }) => this.isLocalProductUrl(product.url));
        await Promise.all(candidates.slice(0, 60).map(async ({ event, product }) => {
          try {
            const url = new URL(product.url, window.location.origin);
            const handle = url.pathname.match(/\/products\/([^/?#]+)/)?.[1];
            if (!handle) return;
            if (!this.productImages.has(handle)) {
              const response = await fetch(`/products/${handle}.js`);
              if (!response.ok) return;
              const productData = await response.json();
              this.productImages.set(handle, {
                title: productData.title || '',
                imageUrl: productData.featured_image || productData.images?.[0] || ''
              });
            }
            const productData = this.productImages.get(handle);
            product.title = productData.title || product.title;
            product.imageUrl = productData.imageUrl;
            if (!event.imageUrl && this.dataset.showImages === 'true') event.imageUrl = product.imageUrl;
          } catch (error) {
            console.debug('[Release calendar] Product details unavailable', error);
          }
        }));
        await this.hydrateCollections();
        this.hydrateBrandLogos();
        this.render();
      }

      hydrateBrandLogos() {
        if (this.dataset.showImages !== 'true') return;
        for (const event of this.events) {
          if (event.imageUrl) continue;
          const brand = this.brandLogos.find((logo) => {
            const name = logo.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            return new RegExp(`(^|[^a-z0-9])${name}([^a-z0-9]|$)`, 'i').test(event.title);
          });
          if (brand) {
            event.imageUrl = brand.image;
            event.brandLogo = true;
          }
        }
      }

      async hydrateCollections() {
        if (this.dataset.showImages !== 'true') return;
        const events = this.events.filter((event) =>
          event.collection && !event.imageUrl && this.isLocalCollectionUrl(event.collection.url)
        );
        await Promise.all(events.slice(0, 20).map(async (event) => {
          try {
            const url = new URL(event.collection.url, window.location.origin);
            const collectionPath = `${url.pathname}${url.search}`;
            if (!url.pathname.match(/\/collections\/[^/?#]+/)) return;
            if (!this.collectionImages.has(collectionPath)) {
              const collectionResponse = await fetch(collectionPath);
              if (!collectionResponse.ok) return;
              const collectionHtml = await collectionResponse.text();
              const collectionDocument = new DOMParser().parseFromString(collectionHtml, 'text/html');
              const main = collectionDocument.querySelector('#MainContent, main') || collectionDocument;
              const productAnchor = main.querySelector('a[href*="/products/"]');
              const productHandle = productAnchor?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
              if (!productHandle) return;

              if (!this.productImages.has(productHandle)) {
                const productResponse = await fetch(`/products/${productHandle}.js`);
                if (!productResponse.ok) return;
                const productData = await productResponse.json();
                this.productImages.set(productHandle, {
                  title: productData.title || '',
                  imageUrl: productData.featured_image || productData.images?.[0] || ''
                });
              }
              const imageUrl = this.productImages.get(productHandle)?.imageUrl || '';
              this.collectionImages.set(collectionPath, imageUrl);
            }
            event.imageUrl = this.collectionImages.get(collectionPath) || '';
            event.collection.imageUrl = event.imageUrl;
          } catch (error) {
            console.debug('[Release calendar] Collection image unavailable', error);
          }
        }));
      }

      isLocalProductUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return url.pathname.includes('/products/');
        } catch (error) {
          return false;
        }
      }

      isLocalCollectionUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return url.pathname.includes('/collections/');
        } catch (error) {
          return false;
        }
      }

      chevron(direction) {
        const path = direction === 'left' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6';
        return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${path}"/></svg>`;
      }

      escape(value = '') {
        const div = document.createElement('div');
        div.textContent = String(value);
        return div.innerHTML;
      }
    }

    customElements.define('release-calendar', ReleaseCalendar);
  }

  } catch(e) { console.error(e); }
})();
})();
